import dynamic from 'next/dynamic';
const DynamicHeadComponent = dynamic(() => import('../components/layout/Head'));
import LayoutComponent from "../components/layout";
import ButtonPrimary from "../components/Button/ButtonPrimary";
import { useEffect } from 'react';
import { useRouter } from 'next/router';

const NotFound = () => {
    const router = useRouter();

    useEffect(() => {
        // var display:any = document.querySelector('#time');
        // var timeleft = 2;
        // var downloadTimer = setInterval(function(){
        //     if(timeleft <= 0){
        //         clearInterval(downloadTimer);
        //         window.location.href = "/";
        //         // router.push("/");
        //     }
        //     display.textContent = timeleft + " giây";
        //     timeleft -= 1;
        // }, 1000);

    }, []);

    return (
        <>
            <DynamicHeadComponent />
            <LayoutComponent
                props={{
                    id: "main"
                }}
                isLoading={false}>
                <div className="flex flex-col items-center justify-center">
                    <div className="flex flex-col items-center gap-3 mt-6 mb-3">
                        <h2 style={{
                            fontWeight: "bold",
                            fontSize: "2rem"
                        }}>
                            Không tìm thấy trang
                        </h2>
                        <p style={{color: "#6B7280"}}>
                            Trang web sẽ tự chuyển về trang chủ trong <b style={{color: "#e03616"}} id="time">2 giây</b>. Xin cảm ơn!!!
                        </p>
                        <ButtonPrimary className="cart_btn-footer-payment" onClick={()=>{
                            window.location.href = "/";
                        }}>Trở lại trang chủ</ButtonPrimary>
                    </div>
                    <img className='mb-3' src="/asset/image/bg_not_found.svg"/>                    
                </div>
            </LayoutComponent>
        </>
    )
}
export default NotFound;
